import { inject, Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { Division } from '@zayan-erp/home-building';
import { API_CONFIG, ApiCallingV2Service } from '@zayan-erp/shared';

@Injectable({
  providedIn: 'root'
})
export class DivisionService {
  #http = inject(ApiCallingV2Service);
  #toastr = inject(ToastrService);
  #apiConfig = inject(API_CONFIG);
  baseUrl = this.#apiConfig.baseUrlV2;

  readDivisions(): Observable<Division[]> {
    return this.#http.getData(`${this.baseUrl}/division`, { showLoader: true, showMessage: false });
  }

  createDivision(division: Omit<Division, 'id'>): Observable<unknown> {
    return this.#http.postData(
      `${this.baseUrl}/division`,
      { showLoader: true, showMessage: true, message: 'Division created successfully' },
      division
    );
  }

  updateDivision(division: Division): Observable<unknown> {
    return this.#http.putData(`${this.baseUrl}/division/${division.id}`, division, {
      showLoader: true,
      showMessage: true,
      message: 'Division updated successfully'
    });
  }

  deleteDivision(ids: string[]): Observable<unknown> {
    return this.#http.postData(
      `${this.baseUrl}/division/bulk-delete`,
      { showLoader: true, showMessage: true, message: 'Division deleted successfully' },
      ids
    );
  }

  getDivisionByCode(divCode: string): Observable<Division> {
    return this.#http.getData(`${this.baseUrl}/division/code/${divCode}`, { showLoader: true, showMessage: false });
  }

  upsertDivisions(divisions: Omit<Division, 'id'>[]): Observable<unknown> {
    return this.#http.postData(
      `${this.baseUrl}/division/bulk-upsert`,
      { showLoader: true, showMessage: true, message: 'Divisions imported successfully' },
      divisions
    );
  }
}
